'use strict';

import { dataMember, required } from 'santee-dcts';

export class StudyGroup {

    @dataMember()
    @required()
    public studyGroupName: string;

    @dataMember()
    @required()
    public groupPk: number;

    @dataMember()
    @required()
    public protocolCode: string;

    @dataMember()
    @required()
    public protocolFk: number;

    @dataMember()
    @required()
    public sponsorName: string;

    @dataMember()
    public createDbDate: string;

    @dataMember()
    public updateDbDate: string;
}
